class Utils {
    static formatDataAddRemoveDays(value, days, operation) {
        const date = value ? new Date(value) : new Date()
        const dayToCount = days ?? 30
        operation === "+" ? date.setDate(date.getDate() + dayToCount) : date.setDate(date.getDate() - dayToCount);

        const dia = date.getDate().toString().padStart(2, '0');
        const mes = (date.getMonth() + 1).toString().padStart(2, '0'); // getMonth() retorna 0-11
        const ano = date.getFullYear();

        const dateString = `${ano}-${mes}-${dia}`;

        return dateString;
    }

    static formatData(value) {
        // format date to dd/mm/yyyy
        let date = value && value.length === 10 ? new Date(value + " 00:00:00") : new Date(value);

        const dia = (date.getDate()).toString().padStart(2, '0');
        const mes = (date.getMonth() + 1).toString().padStart(2, '0'); // getMonth() retorna 0-11
        const ano = date.getFullYear();

        let dateString = dia + '/' + mes + '/' + ano;
        return dateString;
    };

    static formatCnpj(cnpj) {
        // Format CNPJ as needed
        return cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
    }

    static formatCpf(cpf) {
        if (cpf && cpf.length === 11) {// Remove all non-digit characters from the input
            cpf = cpf.replace(/\D/g, '');

            // Limit the string to at most 11 digits; remove excessive leading zeros
            // Ensure the length is cut to 11 if there are more than 11 digits.
            if (cpf.length > 11) {
                cpf = cpf.substring(cpf.length - 11);
            }

            // Format the CPF number as XXX.XXX.XXX-XX
            // This will only format if there are exactly 11 digits present.
            return cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
        } else {
            return cpf
        }
    }

    static validateCPF(cpf) {
        cpf = cpf.replace(/[^\d]+/g, '');
        if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false;

        let soma = 0;
        for (let i = 0; i < 9; i++) soma += parseInt(cpf.charAt(i)) * (10 - i);
        let resto = (soma * 10) % 11;
        if (resto === 10 || resto === 11) resto = 0;
        if (resto !== parseInt(cpf.charAt(9))) return false;

        soma = 0;
        for (let i = 0; i < 10; i++) soma += parseInt(cpf.charAt(i)) * (11 - i);
        resto = (soma * 10) % 11;
        if (resto === 10 || resto === 11) resto = 0;
        return resto === parseInt(cpf.charAt(10));
    }

    static validaCNPJ(cnpj) {
        // Check if CNPJ-specific digits match a CNPJ pattern
        // return number.substr(11, 3) === '000';
        var b = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
        var c = String(cnpj).replace(/[^\d]/g, '')

        if (c.length !== 14)
            return false

        if (/0{14}/.test(c))
            return false

        for (var i = 0, n = 0; i < 12; n += c[i] * b[++i]);
        if (c[12] != (((n %= 11) < 2) ? 0 : 11 - n))
            return false

        for (var i = 0, n = 0; i <= 12; n += c[i] * b[i++]);
        if (c[13] != (((n %= 11) < 2) ? 0 : 11 - n))
            return false

        return true
    }

    static formatTelefone(telefone) {
        // Format CNPJ as needed
        if (telefone.length === 10)
            return telefone.replace(/^(\d{2})(\d{4})(\d{4})$/, '($1)$2-$3');
        if (telefone.length === 11)
            return telefone.replace(/^(\d{2})(\d{1})(\d{4})(\d{4})$/, '($1)$2.$3-$4');
    }

    static formatMoney(inputValue) {
        // Remove leading zeros
        const cleanedValue = inputValue.replace(/^0+/, '');

        // Parse value as number
        const numericValue = parseInt(cleanedValue);

        // Format as BRL currency
        const formattedValue = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(numericValue / 100);

        return formattedValue;
    }

    static formatCurrency = (value) => {

        if (value == null) {
            value = 0;
        }
        return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    }
}

export default Utils;
